import React, { useEffect, useState } from 'react'
import * as S from './styled'
import {
  ActionButtonCard,
  ActionButtonCardCancel,
  CardContainer
} from '../../styles'
import { useModalBox, useOnChangeDetect } from '../../../../contexts'
import moment from 'moment'
import 'moment/locale/pt-br'
import {
  IconEditSvg,
  IconTrashSvg
} from '../../../../assets/icons/svgComponents'
import { getByIdRelevantFact } from '../../../../../main/usecases/services/relevantfact'
import { RelevantFactModel } from '../../../../../domain/models/relevant-fact'
import DeleteRelevantFact from '../../../../components/accordion-table/delete-relevant-fact'
import FactForm, {
  formatDate
} from '../../../../components/timeline/modal/fact'
import { SubHeader } from '../../../../components'

type PageProps = {
  match: any
}

const RelevantFactInternal = ({ match }: PageProps) => {
  const { refresh } = useOnChangeDetect()
  const [data, setData] = useState<RelevantFactModel>()
  const { modalBox } = useModalBox()
  moment.locale('pt-br')
  useEffect(() => {
    ;(async () => {
      if (match.params.idFatoRelevante) {
        const res = await getByIdRelevantFact(
          match.params.idFatoRelevante
        ).load()
        setData(res)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, match.params.idFatoRelevante])

  const handleOpenDeleteServiceModal = () => {
    modalBox(
      <DeleteRelevantFact item={data} />,
      'Deletar Fato Relevante',
      '35%'
    )
  }

  const handleOpenRelevantFactModal = () => {
    if (data) {
      modalBox(
        <FactForm
          cdServiceProps={Number(match?.params.idservico)}
          relevantFact={data}
        />,
        'Validação de dados',
        '46%'
      )
    }
  }

  return (
    <S.Wrapper>
      <SubHeader
        page="Prontuário"
        link={`/meus-pacientes/${match.params.id}/prontuario?serviceId=${match.params.idservico}`}
      />
      {data && (
        <CardContainer>
          <S.TitleInternal>Fato relevante</S.TitleInternal>
          <S.Card>
            <S.HeaderCard>
              <S.TitleHeaderCard>{data.titulo}</S.TitleHeaderCard>
              <S.SubtitleHeaderCard>
                {moment(formatDate(data?.dataFatoRelevante || '')).format(
                  'DD [de] MMMM [de] YYYY'
                )}
                <S.ActionsCard>
                  <span>
                    <ActionButtonCard
                      disabled={!data}
                      onClick={() => handleOpenRelevantFactModal()}
                    >
                      <IconEditSvg />
                    </ActionButtonCard>
                    <div className="ml">
                      <ActionButtonCardCancel
                        disabled={!data}
                        onClick={() => handleOpenDeleteServiceModal()}
                      >
                        <IconTrashSvg />
                      </ActionButtonCardCancel>
                    </div>
                  </span>
                </S.ActionsCard>
              </S.SubtitleHeaderCard>
            </S.HeaderCard>
            <S.ContentCard>{data.descricao}</S.ContentCard>
          </S.Card>
        </CardContainer>
      )}
    </S.Wrapper>
  )
}

export default RelevantFactInternal
